module.exports = __webpack_public_path__ + "static/media/Date.e190b00a.png";